// Single source of truth for the offer. Update these before launch.
export const OFFER = {
  name: 'The 12-Month Wedding Plan™',
  price: 27,
  anchorPrice: 54,
  stackedValue: 109,
  bonusValue: 55,
  currency: 'USD',
  checkoutUrl:
    'https://the-12-month-wedding-plan-organized-by-when-not-by-what.impultienda.ar/checkout',
  supportEmail: 'hello@the12monthweddingplan.com',
  instagramUrl: 'https://instagram.com',
} as const

export const SAVINGS = OFFER.anchorPrice - OFFER.price
